import additionalPriceInfo from './additional-price-info.vue.component';
import { onMounted, onBeforeUnmount, ref } from 'vue';
import {mediaQuery} from '../../scripts/lib/mediaQuery.js';
import {trackAbTestSeen, trackAbTestClicked} from '../tracking/trackingLayer.js';

const templateElement = document.getElementById('ents-preisbereich-template');

export default {
  template: templateElement ? templateElement.innerHTML : '',

  components: {
    additionalPriceInfo,
  },

  props: {
    displayPrice: {
      type: Object,
      required: true,
    },
    deliveryCostCommunicationDecisionId: {
      type: String,
      required: false
    }
  },

  setup(props) {
    const isMobileViewport = ref(mediaQuery.up_to_L);
    const badgeSize = ref('large');
    let deliveryCostCommunicationObserver = null;
    const deliveryCostCommunicationTestId = 'perso-ents-versandkostenkommunikation_detail_product';

    const handleResize = () => {
      badgeSize.value = window.innerWidth < 960 ? 'medium' : 'large';
    };

    function handleDeliveryCostCommunicationIntersection(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          trackAbTestSeen(deliveryCostCommunicationTestId, props.deliveryCostCommunicationDecisionId);
          deliveryCostCommunicationObserver.disconnect();
        }
      });
    }

    onMounted(() => {
      handleResize();

      const deliveryCostCommunicationElement = document.querySelector('[data-test-delivery-cost-communication]');
      if (deliveryCostCommunicationElement && props.deliveryCostCommunicationDecisionId) {
        deliveryCostCommunicationObserver = new IntersectionObserver(handleDeliveryCostCommunicationIntersection);
        deliveryCostCommunicationObserver.observe(deliveryCostCommunicationElement);

        deliveryCostCommunicationElement.addEventListener('click', () => {
          trackAbTestClicked(deliveryCostCommunicationTestId, props.deliveryCostCommunicationDecisionId);
        });
      }
      window.addEventListener('resize', handleResize);
    });

    onBeforeUnmount(() => {
      if (deliveryCostCommunicationObserver) {
        deliveryCostCommunicationObserver.disconnect();
      }
      window.removeEventListener('resize', handleResize);
    });

    return {
      badgeSize,
      isMobileViewport
    };
  },

};
